import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

const RESOURCE = "/tenant/profile";

export interface TenantProfile {
  id: number;
  name: string;
  public_slug: string | null;
  about_text: string | null;
  instagram_url: string | null;
  mini_site_url: string | null;
}

export interface UpdateTenantProfilePayload {
  public_slug?: string | null;
  about_text?: string | null;
  instagram_url?: string | null;
}

export const getTenantProfile = (): Promise<ApiResponse<TenantProfile>> =>
  api.get<ApiResponse<TenantProfile>>(RESOURCE);

export const updateTenantProfile = (
  payload: UpdateTenantProfilePayload
): Promise<ApiResponse<TenantProfile>> =>
  api.update<ApiResponse<TenantProfile>>(RESOURCE, payload);
